module.exports = __webpack_public_path__ + "images/none-7c7a173ec43592e9cabfe9a8eec271db.jpg";